import { action, payload } from "ts-action";
import * as actions from "../../../constants";
import {
  GiftGroup,
  GiftItem,
  IStore,
  PosEntityGiftGroups,
} from "../../../types";

export const getMultiPosGiftGroups = action(
  actions.getMultiPosGiftGroupsAction.requested
);

export const getMultiPosGiftGroupsSuccess = action(
  actions.getMultiPosGiftGroupsAction.fulfilled,
  payload<PosEntityGiftGroups[]>()
);

export const getMultiPosGiftGroupsFailure = action(
  actions.getMultiPosGiftGroupsAction.rejected,
  payload<Error>()
);

export const modifyMultiPosGiftGroups = action(
  actions.modifyMultiPosGiftGroupsAction.requested
);

export const modifyMultiPosGiftGroupsSuccess = action(
  actions.modifyMultiPosGiftGroupsAction.fulfilled,
  payload<{ pos_entity_id: string }>()
);

export const modifyMultiPosGiftGroupsFailure = action(
  actions.modifyMultiPosGiftGroupsAction.rejected,
  payload<Error>()
);

export const getGiftGroups = action(actions.getGiftGroupsAction.requested);

export const getGiftGroupsSuccess = action(
  actions.getGiftGroupsAction.fulfilled,
  payload<GiftGroup[]>()
);

export const getGiftGroupsFailure = action(
  actions.getGiftGroupsAction.rejected,
  payload<Error>()
);

export const modifyGiftGroups = action(
  actions.modifyGiftGroupsAction.requested
);

export const modifyGiftGroupsSuccess = action(
  actions.modifyGiftGroupsAction.fulfilled,
  payload<GiftGroup[]>()
);

export const modifyGiftGroupsFailure = action(
  actions.modifyGiftGroupsAction.rejected,
  payload<Error>()
);

export const updateGiftGroupItems = action(
  actions.ACTION_UPDATE_GIFT_GROUP_ITEMS,
  payload<{
    group_id: string;
    item: GiftItem;
  }>()
);

export const updateMultiPosGiftGroupItems = action(
  actions.ACTION_UPDATE_MULTI_POS_GIFT_GROUP_ITEMS,
  payload<{
    group_id: string;
    item: GiftItem;
    pos_entity_id: string;
  }>()
);

export const updateGiftGroupItemsResult = action(
  actions.UPDATE_GIFT_GROUP_ITEM_RESULT,
  payload<{
    item: GiftItem;
    category_id: string;
    success: boolean;
  }>()
);

export const removeGiftGroupItem = action(
  actions.ACTION_REMOVE_GIFT_GROUP_ITEM,
  payload<{
    group_id: string;
    item: GiftItem;
    category_id: string;
  }>()
);

export const removeMultiPosGiftGroupItem = action(
  actions.ACTION_REMOVE_MULTI_POS_GIFT_GROUP_ITEM,
  payload<{
    group_id: string;
    item: GiftItem;
    pos_entity_id: string;
  }>()
);

export const updateGiftGroupTitle = action(
  actions.ACTION_UPDATE_GIFT_GROUP_TITLE,
  payload<{
    group_id: string;
    name: string;
    ar_name: string;
    is_ar_renamed?: 0 | 1;
  }>()
);

export const updateMultiPosGiftGroupTitle = action(
  actions.ACTION_UPDATE_MULTI_POS_GIFT_GROUP_TITLE,
  payload<{
    group_id: string;
    name: string;
    ar_name: string;
    is_ar_renamed?: 0 | 1;
    pos_entity_id: string;
  }>()
);

export const addEmptyMultiPosGiftGroupItem = action(
  actions.ACTION_ADD_EMPTY_MULTI_POS_GIFT_GROUP_ITEM,
  payload<{
    group_id: string;
    pos_entity_id: string;
  }>()
);

export const addEmptyMultiPosGiftGroup = action(
  actions.ACTION_ADD_EMPTY_MULTI_POS_GIFT_GROUP,
  payload<{
    pos_entity_id: string;
  }>()
);

export const addLoyaltyPosGiftItem = action(
  actions.ACTION_ADD_LOYALTY_POS_GIFT_ITEM,
  payload<{
    price: number;
    name: string;
    promo_code?: string;
    is_voucher: 0 | 1;
    promo_id: string;
    image: string;
    order: number;
    is_special_item?: 0 | 1;
  }>()
);

export const setGiftGroupsCurrency = action(
  actions.getStoreAction.fulfilled,
  payload<IStore>()
);

export const addEmptyGiftGroup = action(
  actions.ACTION_ADD_EMPTY_GIFT_GROUP,
  payload<{
    pos_entity_id?: string;
  }>()
);

export const addEmptyGiftGroupItem = action(
  actions.ACTION_ADD_EMPTY_GIFT_GROUP_ITEM,
  payload<{
    group_id: string;
    pos_entity_id?: string;
  }>()
);
